import styled, { css } from 'styled-components';
import { body2, caption, colors, smallShadow, spacing, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { ItemStatus } from '../JourneyReview.constants';

export const styleLookUp: {
  [key in ItemStatus]: {
    text: string;
    icon: string;
  };
} = {
  [ItemStatus.Incomplete]: {
    text: `${colors.textPrimary}`,
    icon: `${colors.purple70}`,
  },
  [ItemStatus.Complete]: { text: `${colors.textDisabled}`, icon: `${colors.textDisabled}` },
  [ItemStatus.Error]: {
    text: `${colors.textDestructive}`,
    icon: `${colors.textDestructive}`,
  },
};

export const JourneyReviewListItemBodyHeader = styled.div<{ $statusStyle: ItemStatus }>`
  ${subtitle2};
  ${({ $statusStyle }) => `color: ${styleLookUp[$statusStyle].text};`};
`;

export const JourneyReviewListItemBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.quarter};
  flex: 1 0 0;
`;

export const JourneyReviewListItemBodyDescription = styled.div`
  ${body2}
  color: ${colors.textSecondary};
`;

export const JourneyReviewListItemBodyFooter = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(4)};
  ${caption}
  color: ${colors.textSecondary};
`;

export const JourneyReviewListItemContainer = styled.div<{ onClick?: () => void }>`
  display: flex;
  padding: ${spacing.base};
  align-items: flex-start;
  gap: ${spacing.half};

  border-bottom: 1px solid ${colors.borderPrimarySubtle};

  > svg {
    margin-top: ${pxToRem(2)};
  }

  ${({ onClick }) =>
    onClick
      ? css`
          cursor: pointer;
          :hover {
            background: ${colors.backgroundPrimaryHover};
          }
        `
      : ''}
`;

export const JourneyReviewListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-radius: ${pxToRem(6)};
  ${smallShadow}
  background: ${colors.backgroundPrimary};
`;
